export default __webpack_public_path__ + "static/media/praveen.2a9ca874.png";